import React from "react"

export const COLUMNS = [
  {
    Header: "Tax Name",
    accessor: "name",
  },
  {
    Header: "Tax Percentage",
    accessor: "percentage",
  },

  {
    Header: "",
    accessor: "Edit",
    Cell: ({ cell: {} }) => (
      <img
        className="eye-icon"
        src={"../../../assets/images/CRedit.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
  {
    Header: "",
    accessor: "Delete",
    // @ts-ignore
    Cell: ({ cell }) => (
      <img
        className="eye-icon"
        src={"../../../assets/images/CRdelete.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
